import React, { useEffect, useMemo, useState } from "react";
import { Card, CardBody, Col, Row, Spinner } from "reactstrap";
import AdvanceSearch from "../../../CommonComponents/AdvanceSearch";
import { useSelector } from "react-redux";
import visileColumns from "./visileColumns";
// import TelerikDataTable from "../../../CommonComponents/TelerikDataTable";
import TelerikDataTable from "../../../CommonComponents/TelerikDataTable/indexV2";

import  { forwardRef, useImperativeHandle } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { Autocomplete, FormControlLabel, Radio, RadioGroup, TextField } from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { advanceSearch } from "../../../_helper/services/advanceSearchv2";
import { post, put, remove } from "../../../_helper/api_helper";
import { ShowError, ShowSucess } from "../../../_helper/helper";
import { loadingPanel } from "../../../CommonComponents/CommonFunction";

const AssignSupervisorTable = (props, ref) => {
    const id = 'fn_GetEmployeesByDepartment'
    const { columns, loadingSearch, ColumnsSorted, searchParameter, searchResultsV2 } = useSelector((state) => state.advanceSearchv2Reducer);
    const { results, rowCount } = useMemo(() => {
        const searchResult = searchResultsV2[id] || { results: [], rowCount: 0 };
        return {
          results: searchResult.results,
          rowCount: searchResult.rowCount,
        };
      }, [searchResultsV2, id]);
    const { filter: storeFilter, pageSize: storePageSize } = useSelector((state) => state.CommonReducer);
    const [page, setPage] = useState(1);
    const [additionalWhere, setAdditionalWhere] = useState("");
    const { sort } = useSelector((state) => state?.CommonReducer) || {};
    const [sortData, setSortData] = useState([
        // { field: "ANNOUNCEMENT_ID", dir: "desc" }  
    ]);
    const [searchParams, setSearchParams] = useState([]);
    const [pageSize, setPageSize] = useState(storePageSize[id] || 100);

    useEffect(() => {
        if (searchParameter[id]?.searchParams?.length > 0) {
            setSearchParams(JSON.parse(searchParameter[id]?.searchParams));
        }
    }, [searchParameter]);

    const [sortedColumns, setSortedColumns] = useState(visileColumns);
    const [isOpen, setIsOpen] = useState(false);
    const [departmentOptions,setDepartmentOptions] = useState([])
    const [loading, setLoading] = useState(false);
    const [employeeOption,setEmployeeOption] = useState([])
    const [add,setAdd] = useState(false)
    const [submitLoading, setSubmitLoading] = useState(false);
    const [toggleApiCall,setToggleApiCall] = useState(false)
    const [updateData,setUpdateData] = useState({})
    const [deleteLoader,setDeleteLoader] = useState(false)

    const actions = useMemo(() => {
        return [
            {
                title: "Update",
                icon: { iconName: "k-icon k-i-pencil" },
                className: "font-primary",
                style: { cursor: "pointer" },
                action: (props) => {
                    console.log("added to table", props.dataItem);
                    setUpdateData({...props.dataItem})
                    // const {Dept_Code,DepartmentName,EmployeeName,PocEmployeeid,IsActive} = props.dataItem
                    // formik.setFieldValue("dept", {label:DepartmentName,value:Dept_Code});
                    // formik.setFieldValue("empl", {label:EmployeeName,value:PocEmployeeid});
                    // formik.setFieldValue("status", IsActive?'active':'inactive');
                    // getEmployeeOption({label:DepartmentName,value:Dept_Code})
                    toggle();
                },
                
            },
            {
                title: "Remove Supervisor",
                icon: { iconName: "k-icon k-i-delete" },
                className: "font-primary",
                style: { cursor: "pointer" },
                action: (props) => {
                    // setEligibilityTableShow(props.dataItem)
                    deleteSupervisorHandler(props.dataItem)
                },
                isVisible: (dataProps) => {
                    // console.log("dataProps1221", dataProps?.ANNOUNCEMENT_ID?.trim(),ANNOUNCEMENT_ID_Value);
                    return (
                        dataProps?.IsAssign
                    );
                  },
            }
        ];
    }, []);


    const getDepartmentOptions = async() => {
        const payload = {
            tableName: "employeemaster",
            searchParams: "[]",
            columns: "DPDV,Dept_No",
            location: "global",
            pageNumber: 1,
            pageSize: 9999,
            sortData: "",
            additionalWhere: `id = '1036'`,
            qID: 0,
          };
        try{
            const response = await advanceSearch(payload)
            const {results} = response
            // if(results?.length>0){
            //     const deptOptions = results.map((item)=>({
            //         label:item?.DepartmentName??"",
            //         value:item?.Dept_Code
            //     }))
            //     setDepartmentOptions(deptOptions)
            // }
            if(results?.length>0){
              setSearchParams([
                {
                  columnName: "DeptNo",
                  operator: "=",
                  value: results?.[0]?.Dept_No,
                  dataType: "varchar(max)",
                  logicOperator: "AND",
                }
              ])
            }
            // setAdditionalWhere(`Dept_no = '${results?.[0]?.Dept_No}'`)
            console.log(response,'deparment response')
        }catch(error){
            
        }
    }

    useEffect(()=>{
        getDepartmentOptions()
    },[])

    const handlePageChange = (event) => {
        setPage(event.page.skip / event.page.take + 1);
        setPageSize(event.page.take);
    };

    const handleSortChange = (sort) => {
        setSortData(sort);
        setPage(1);
        setPageSize(100);
    };

    const handleFilterChange = (data) => {
        setAdditionalWhere(data);
        setPage(1);
        setPageSize(100);
    };

    const handlePageSizeChange = (event) => {
        setPageSize(event.target.value);
        setPage(1);
    };

    const toggle = () => setIsOpen(!isOpen);

  
   // Formik setup for validation
   const formik = useFormik({
    initialValues: {
      // status: 'active',
      // dept: null,
      empl: null,
    },
    validationSchema: Yup.object({
      // status: Yup.string().required('Status is required'),
      // dept: Yup.object().nullable().required('Department is required'),
      empl: Yup.object().nullable().required('Employee Name is required'),
    }),
    onSubmit: (values) => {
        submitHandler(values)
    //   toggle();
    },
  });

  const deleteSupervisorHandler = async(deleteData) => {
    setDeleteLoader(true)
    try{
      await remove(`${process.env.REACT_APP_API_DOTNET_URL}/EmployeeSupervision/Delete/SoftDeleted?Id=${deleteData?.id}`,{})
      ShowSucess("Supervisor Removed Sucessfully")
      setToggleApiCall((prev)=>!prev)
    }catch(error){

    }finally{
    setDeleteLoader(false)
    }
  }

  const submitHandler = async(values) => {
    const {empl:{value:empl_code}} = values
    setSubmitLoading(true);
    try{
        const payload = {
          id: updateData?.id,
          supervisorEmployeeId: empl_code,
          employeeId: updateData?.employeeid,
          supervisionRole: "Supervisor",
        };
    if(!payload?.id){
        delete payload['id']
    }
        if(!payload?.id)
        await post(`${process.env.REACT_APP_API_DOTNET_URL}/EmployeeSupervision/EmployeeSupervisionAdd`,payload)
        else await put(`${process.env.REACT_APP_API_DOTNET_URL}/EmployeeSupervision/EmployeeSupervisionUpdated`,payload)
        toggle();
        ShowSucess("Supervisor Assigned Sucessfully")
        // if(add) setAdd(false)
        setToggleApiCall((prev)=>!prev)
        clearForm()
    }catch(error){
        ShowError("Something went wrong!")
    }finally{
        setSubmitLoading(false);
    }
    // console.log('Form submitted:', dept_code,empl_code);
    // const response 
  }

  const getEmployeeOption = async(value) =>{
    setLoading(true);
      try {
        const payload = {
          tableName: "fn_verfiyEmployeeDep",
          searchParams: JSON.stringify([
            {
              columnName: "dept_no",
              operator: "=",
              value: searchParams?.[0]?.value,
              dataType: "varchar(max)",
              logicOperator: "AND",
            },
          ]),
          columns: "*",
          location: "global",
          pageNumber: 1,
          pageSize: 9999,
          sortData: "",
          additionalWhere: "",
          qID: 0,
        };
        const response = await advanceSearch(payload);
        const {results} = response
        if(results?.length>0){
            const emplOptions = results.map((item)=>({
                label:item?.EmployeeName??"",
                value:item?.employeeid
            }))
            setEmployeeOption(emplOptions)
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
  }

  useEffect(()=>{
    if(searchParams?.[0]?.value){
      getEmployeeOption()
    }
  },[searchParams])

    const handleFirstAutocompleteChange = async (e, value) => {
      formik.setFieldValue("dept", value);
      formik.setFieldValue("empl", "")
      // setEmployeeOption([]);
      await getEmployeeOption(value)
    };
  
    const clearForm = () => {
        formik.resetForm(); 
        // setEmployeeOption([]); 
      };
  

  return (
    <Row>
      {deleteLoader && loadingPanel()}
      <Col sm="12" className="page-content">
        <Card>
          <CardBody>
            <div>
                {searchParams.length>0 && 
                <TelerikDataTable
                id={"fn_GetEmployeesByDepartment"}
                pageNumber={page}
                pageSize={pageSize}
                totalCount={rowCount}
                skip={(page - 1) * pageSize}
                take={pageSize}
                data={results || []}
                sortData={sortData}
                tableName={"fn_GetEmployeesByDepartment"}
                searchParams={searchParams}
                additionalWhere={additionalWhere}
                onFilterChange={handleFilterChange}
                onSortChange={handleSortChange}
                onPageChange={handlePageChange}
                onPageSizeChange={handlePageSizeChange}
                selectedColumns={sortedColumns}
                setSortedColumns={setSortedColumns}
                loading={loadingSearch}
                enableFooterCell={false}
                toggleApiCall={toggleApiCall}
                // dataLocation="pmis-global"
                actions={actions}
                pocBool={true}
              />
                }
            </div>
          </CardBody>

          <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>Assign Supervisor</ModalHeader>
            <ModalBody>
              <form onSubmit={formik.handleSubmit}>
                {/* <RadioGroup
                  name="status"
                  value={formik.values.status}
                  onChange={(e) =>{
                    if(e.target.value!='active'){
                    formik.setFieldValue("empl", {label:updateData.EmployeeName,value:updateData.PocEmployeeid});
                    }
                    formik.setFieldValue("status", e.target.value)
                  }
                  }
                  row
                >
                  <FormControlLabel
                    value="active"
                    control={<Radio />}
                    label="Active"
                  />
                  <FormControlLabel
                    value="inactive"
                    control={<Radio />}
                    disabled={add}
                    label="Inactive"
                  />
                </RadioGroup> */}
                {/* <br /> */}
                {/* <Autocomplete
                  options={departmentOptions}
                  getOptionLabel={(option) => option.label}
                  onChange={handleFirstAutocompleteChange}
                  value={formik.values.dept || null}
                  disabled={!add || formik.values.status!="active"}
                  renderInput={(params) => ( */}
                    <TextField
                      // {...params}
                      label="Employee Name"
                      // error={formik.touched.dept && Boolean(formik.errors.dept)}
                      // helperText={formik.touched.dept && formik.errors.dept}
                      size="small"
                      disabled={true}
                      value={updateData?.EmployeeName??""}
                      fullWidth
                    />
                  {/* )}
                /> */}
                <br />
                <br />
                <Autocomplete
                  options={employeeOption.filter((item)=>item?.employeeid!=updateData?.employeeid)}
                  getOptionLabel={(option) => option.label}
                  onChange={(e, value) => formik.setFieldValue("empl", value)}
                  value={formik.values.empl || null}
                  // disabled={formik.values.status!="active"}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Employee as Supervisor"
                      error={formik.touched.empl && Boolean(formik.errors.empl)}
                      helperText={formik.touched.empl && formik.errors.empl}
                      size="small"
                      // disabled={formik.values.status!="active"}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {loading ? <Spinner size="sm" /> : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
                <ModalFooter>
                  <Button color="secondary" onClick={()=>
                    {
                        // setAdd(false)
                        clearForm()
                        toggle()
                    }
                    } disabled={submitLoading}>
                    Cancel
                  </Button>
                  <Button color="primary" type="submit" disabled={submitLoading}>
                  {submitLoading ? <Spinner size="sm" /> : 'Submit'}
                  </Button>
                </ModalFooter>
              </form>
            </ModalBody>
          </Modal>
        </Card>
      </Col>
    </Row>
  );
};

export default AssignSupervisorTable;
